import { useEffect, useState } from 'react';
import { uploadFile } from '../Services/Lessons';
import { useForm } from "react-hook-form";
import uuid from 'react-uuid';
import TimePicker from 'react-time-picker';

const EditVideosOfLesson = ({ setVideos, videos, lessonId }) => {
    const Swal = require('sweetalert2')
    // const [durationValue, setDurationValue] = useState('00:00');
    const [duration, setDuration] = useState('');

    // img uplod
    const [picture1, setPicture1] = useState(null)

    const imagesPreview1 = (e) => {
        if (e.target.files[0]) {
            setPicture1(e.target.files[0])
        }
    }
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    // uplaod video
    const [picture, setPicture] = useState(null)
    const [imgData, setImgData] = useState(null)
    const imagesPreview = (e) => {
        if (e.target.files[0]) {
            setPicture(e.target.files[0])
            const reader = new FileReader();
            reader.onload = function (e) {
                setImgData(true)
            };
            reader.readAsDataURL(e.target.files[0])
        } else {
            setImgData(false)
        }
        // setting video duration

        var file = e.target.files[0],
            mime = file.type,
            rd = new FileReader();

        rd.onload = function (e) {

            var blob = new Blob([e.target.result], { type: mime }),
                url = (URL).createObjectURL(blob),
                video = document.createElement("video");

            video.preload = "metadata";
            video.addEventListener("loadedmetadata", function () {
                // show duration
                let time = video.duration
                let minutes = Math.floor(time / 60);
                let seconds = time - minutes * 60;
                // set duration in 00:00 format
                setDuration("00" + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + Math.floor(seconds)).slice(-2))
            });
            video.src = url;
        };
        rd.readAsArrayBuffer(file);
    }

    const [loder, setLoder] = useState(false)

    // getting form data
    const onSubmit = async (data) => {
        if (imgData !== null && picture !== null && picture1 !== null) {
            setLoder(true)
            // upload img
            const formData1 = new FormData();
            formData1.append("", picture1);
            const imageResponse = await uploadFile(formData1);
            // data.ImagePath = imageResponse.data.data.filePath;

            // upload video
            const formData3 = new FormData();
            formData3.append("", picture);
            const videourl = await uploadFile(formData3);
            // data.videoPath = videourl.data.data.url;

            // checking if file size is large

            if (!videourl) {
                Swal.fire({
                    title: "Video File is Too Large",
                    timer: 2000,
                    icon: 'error',
                    showConfirmButton: false,
                })
                setLoder(false)
            }

            const v = [...videos];
            v.push({
                id: uuid(),
                lessonVideoId: 0,
                lessonId: parseInt(lessonId),
                videoPath: videourl.data.data.url,
                videoThumbnail: imageResponse.data.data.url,
                videoTitle: data.videoTitle,
                duration: duration,
            })
            setVideos(v);
            reset({ videoTitle: "" });
            setDuration('')
            setImgData(null)
            setPicture1(null)
            setPicture(null)
            document.querySelector('.form_input_videos').reset()
            setLoder(false)
        } else {
            Swal.fire({
                title: "Files are missing",
                timer: 1400,
                icon: 'error',
                showConfirmButton: false,
            })
        }
    }
    return (
        <div>
            <form className='form_input_videos'>
                <div className="user-table-head">
                    <div className="userHeading">
                        <h2>Upload Lesson Detail's</h2>
                    </div>
                </div>
                <div className='dFlex'>
                    <div className="therapist_name">
                        <input autocomplete="off" type="text" name="uname" placeholder="Video Title" {...register("videoTitle", { required: true })} />
                    </div>
                    {errors.videoTitle && <span className='eror'>This field is required</span>}
                    <div className="therapist_name">
                        <input type="file" className='uploadFile' accept="image/*" onChange={imagesPreview1} required="true" />
                    </div>
                    <div className='durationKLye'>
                        {/* <TimePicker onChange={setDurationValue} value={durationValue} format="mm:ss" clearIcon={true} clockIcon={false} disableClock={true} required={true} /> */}
                    </div>
                </div>
                <div className="lessonDetailsBtn finallessonDetailsBtn">
                    <div className='hiddenField'>
                        <label htmlFor="v" />
                        <input accept=".mp4" id="v" type="file" onChange={imagesPreview} required="true" />
                        {imgData ? <img className='sizeSet' src='/assets/images/tick1.png' alt='' /> : ""}
                    </div>
                    <button className='uploadBtn'><img src="/assets/images/Upload Video Icon.svg" alt="" /></button>
                </div>
                <div className='addLEssonBtnDiv'>
                    {
                        (loder === true) ?
                            <div className="relative">
                                <div className="loader alignAdd"></div>
                                <button className="bttn addLEssonBtn" disabled>Save</button>
                            </div>
                            :
                            <button className="bttn addLEssonBtn" onClick={handleSubmit(onSubmit)} >Save</button>
                    }
                </div>
            </form>
        </div >
    )
}

export default EditVideosOfLesson